/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisibilityConditionOperator } from './VisibilityConditionOperator';
import {
    VisibilityConditionOperatorFromJSON,
    VisibilityConditionOperatorFromJSONTyped,
    VisibilityConditionOperatorToJSON,
    VisibilityConditionOperatorToJSONTyped,
} from './VisibilityConditionOperator';
import type { VisibilityConditionType } from './VisibilityConditionType';
import {
    VisibilityConditionTypeFromJSON,
    VisibilityConditionTypeFromJSONTyped,
    VisibilityConditionTypeToJSON,
    VisibilityConditionTypeToJSONTyped,
} from './VisibilityConditionType';

/**
 * 
 * @export
 * @interface SectionSpawnTriggerDto
 */
export interface SectionSpawnTriggerDto {
    /**
     * Reference key of the section template to spawn
     * @type {string}
     * @memberof SectionSpawnTriggerDto
     */
    templateReference: string;
    /**
     * 
     * @type {VisibilityConditionType}
     * @memberof SectionSpawnTriggerDto
     */
    sectionSpawnConditionType: VisibilityConditionType;
    /**
     * Expected value to trigger spawning
     * @type {string}
     * @memberof SectionSpawnTriggerDto
     */
    sectionSpawnExpectedValue?: string;
    /**
     * 
     * @type {VisibilityConditionOperator}
     * @memberof SectionSpawnTriggerDto
     */
    sectionSpawnOperator: VisibilityConditionOperator;
}



/**
 * Check if a given object implements the SectionSpawnTriggerDto interface.
 */
export function instanceOfSectionSpawnTriggerDto(value: object): value is SectionSpawnTriggerDto {
    if (!('templateReference' in value) || value['templateReference'] === undefined) return false;
    if (!('sectionSpawnConditionType' in value) || value['sectionSpawnConditionType'] === undefined) return false;
    if (!('sectionSpawnOperator' in value) || value['sectionSpawnOperator'] === undefined) return false;
    return true;
}

export function SectionSpawnTriggerDtoFromJSON(json: any): SectionSpawnTriggerDto {
    return SectionSpawnTriggerDtoFromJSONTyped(json, false);
}

export function SectionSpawnTriggerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionSpawnTriggerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'templateReference': json['templateReference'],
        'sectionSpawnConditionType': VisibilityConditionTypeFromJSON(json['sectionSpawnConditionType']),
        'sectionSpawnExpectedValue': json['sectionSpawnExpectedValue'] == null ? undefined : json['sectionSpawnExpectedValue'],
        'sectionSpawnOperator': VisibilityConditionOperatorFromJSON(json['sectionSpawnOperator']),
    };
}

export function SectionSpawnTriggerDtoToJSON(json: any): SectionSpawnTriggerDto {
    return SectionSpawnTriggerDtoToJSONTyped(json, false);
}

export function SectionSpawnTriggerDtoToJSONTyped(value?: SectionSpawnTriggerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'templateReference': value['templateReference'],
        'sectionSpawnConditionType': VisibilityConditionTypeToJSON(value['sectionSpawnConditionType']),
        'sectionSpawnExpectedValue': value['sectionSpawnExpectedValue'],
        'sectionSpawnOperator': VisibilityConditionOperatorToJSON(value['sectionSpawnOperator']),
    };
}

